import React from 'react';
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {LuLayoutDashboard} from "react-icons/lu";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import API from "../../Services/API";
import Loading from "../../Layouts/Loading";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { saveAs } from 'file-saver';

const currencyFormat = Intl.NumberFormat('en-US');

function VendorSaleReport() {

    const [dateFrom, setDateFrom] = React.useState(null);
    const [dateTo, setDateTo] = React.useState(null);
    const [report, setReport] = React.useState([]);
    const [isLoaded, setIsLoaded] = React.useState(true);

    const onGetReport = (excel = 0) => {
        const fromMonth = dateFrom?.toDate?.().getMonth() - (-1);
        const toMonth = dateTo?.toDate?.().getMonth() - (-1);

        let params = {
            count: 100,
            page: 1,
            list: 0,
            orderBy: 'created_at',
            orderType: 'desc',
            excel,
            date_from: typeof dateFrom?.toDate?.().getFullYear() !== "undefined" ? dateFrom?.toDate?.().getFullYear() + '-' + fromMonth + '-' + dateFrom?.toDate?.().getDate() + ' 00:00' : '',
            date_to: typeof dateTo?.toDate?.().getFullYear() !== "undefined" ? dateTo?.toDate?.().getFullYear() + '-' + toMonth + '-' + dateTo?.toDate?.().getDate() + ' 23:59' : '',

        }

        setIsLoaded(false)

            API.getVendorReport(params)
                .then((response) => {
                    setIsLoaded(true)
                    if (!excel) {
                        setReport(response.data);
                    } else {
                        const outputFilename = `ngkhBrands${Date.now()}.xlsx`;

                        const blob = new Blob([response], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        });

                        saveAs(blob, outputFilename);
                    }

                })
                .catch((error) => {
                    setIsLoaded(true)
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });

    }


    return (
        <React.Fragment>
            <Header/>
            {
                !isLoaded && <Loading/>
            }
            <Navbar page="vendors"/>
            <Toast/>
            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <LuLayoutDashboard className='ms-2'/>
                        گزارش فروش و برگشتی نمایندگان در بازه انتخابی
                    </h1>

                </div>

                <section className="section dashboard">
                    <div className="row rtl">
                        <div className="col--12">

                            <div className="card info-card customers-card">


                                <div className="card-body">

                                    <div className="row filter-box mb-5 pb-2 rounded text-small-2">
                                        <div className="col-md-3  text-start mt-5">
                                        <span className='float-end mt-2'>
                                             از تاریخ:
                                        </span>
                                            <DatePicker

                                                onChange={(val) => {
                                                    setDateFrom(val)

                                                }}
                                                calendar={persian}
                                                locale={persian_fa}
                                                calendarPosition="bottom-right"
                                                className="rmdp-mobile"
                                                //value={this.state.date_from}

                                            />

                                        </div>
                                        <div className="col-md-3 text-start mt-5">
                                        <span className='float-end mt-2'>
                                            تا تاریخ:
                                        </span>
                                            <DatePicker
                                                //value={this.state.date_to}
                                                onChange={(val) => {
                                                    setDateTo(val)

                                                }}
                                                calendar={persian}
                                                locale={persian_fa}
                                                calendarPosition="bottom-right"
                                                className="rmdp-mobile"

                                            />
                                        </div>
                                        <div className='col-md-3 mt-3'>
                                            <button className='btn btn-success w-100 mt-4 text-small-1'
                                                    onClick={() => {
                                                        onGetReport(0)
                                                    }}
                                            >
                                                دریافت گزارش
                                            </button>
                                        </div>
                                        <div className='col-md-3 mt-3'>
                                            <button className='btn btn-primary w-100 mt-4 text-small-1'
                                                    onClick={() => {
                                                        onGetReport(1)
                                                    }}
                                            >
                                                دریافت اکسل
                                            </button>
                                        </div>
                                    </div>

                                </div>


                            </div>

                        </div>
                        {
                            report.length > 0 &&

                            <div className="col-12">
                                <div className="card info-card sales-card">
                                    <div className="card-body rtl">


                                        <table className="table mt-5 text-center table-striped">
                                            <thead>
                                            <tr className='text-small-2 text-muted'>
                                                <th scope="col" className='bg-success-subtle rounded-end-3'> نماینده</th>
                                                <th scope="col" className='bg-success-subtle'>تعداد فروش</th>
                                                <th scope="col" className='bg-success-subtle'>فروش آمپری</th>
                                                <th scope="col" className='bg-success-subtle'>تعداد برگشتی</th>
                                                <th scope="col" className='bg-success-subtle rounded-start-3'>برگشتی آمپری</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                report?.map((vendor) => {
                                                    return (
                                                        <tr key={vendor.id}
                                                            role='button'
                                                        >

                                                            <td>
                                                                {vendor.name}

                                                            </td>
                                                            <td>

                                                                {currencyFormat.format(vendor.status_8_count)}
                                                            </td>
                                                            <td>
                                                                {currencyFormat.format(vendor.status_8_amp)}

                                                            </td>
                                                            <td>
                                                                {currencyFormat.format(vendor.status_10_count)}

                                                            </td>
                                                            <td>
                                                                {currencyFormat.format(vendor.status_10_amp)}

                                                            </td>


                                                        </tr>
                                                    )
                                                })
                                            }
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        }

                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default VendorSaleReport;